import { useQuery, UseQueryResult } from 'react-query';
import api from '~/services/api';

const fetchLojasUsuario = async () => {
  const { data } = await api.get('/lojas/usuario');
  if (!data.success || !data.data) throw new Error('Erro ao buscar lojas');
  return data.data;
};

export const useLojasUsuario = (enabled: boolean): UseQueryResult<any, Error> =>
  useQuery('lojasUsuario', fetchLojasUsuario, {
    enabled,
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    retry: 1,
  });
